import { OrderVariable } from './common'
import { Requirements } from './requirements'

export type VideoConfigVariant = {
  id: number | string
  title: string | null
  desc: string | null
  url: string
  elaiId: string | null
  elaiVersion: string | null
  overlayTime: number | null
  requires: Requirements | null
}

export type VideoConfig = {
  id: number | string
  variable: OrderVariable
  locale: string
  variants: VideoConfigVariant[]
}
